/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {
  getBalnceDue: [],
  getOverridden: [],
  getPaidInFull: [],
  getAccRecFieldvalues: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.SINGLE_ACC_REC_NDC_TABLE:
      return {
        ...state,
        getSingleAccRecNDCList: action.getSingleAccRecNDCList,
      };
    case actiontypes.SINGLE_ACC_REC_FIELD_VALUES:
      let getAccRecPgmVal = Object.keys(action.getAccRecFieldvalues)[0];
      if (state.getAccRecFieldvalues.length != 0) {
        let main = state?.getAccRecFieldvalues?.forEach(function (obj) {
          delete obj[getAccRecPgmVal];
        });
      }
      return {
        ...state,
        getAccRecFieldvalues: [
          ...state.getAccRecFieldvalues,
          action.getAccRecFieldvalues,
        ],
      };
    case actiontypes.QAR_BALANCE_DUE:
      let getAccRecPgmBLVal = Object.keys(action?.getBalnceDue)?.[0];
      if (state?.getBalnceDue?.length != 0) {
        let main = state?.getBalnceDue?.forEach(function (obj) {
          delete obj[getAccRecPgmBLVal];
        });
      }
      return {
        ...state,
        getBalnceDue: [...state?.getBalnceDue, action?.getBalnceDue],
      };
    case actiontypes.QAR_OVERRIDDEN:
      let getAccRecPgmORVal = Object.keys(action?.getOverridden)?.[0];
      if (state?.getOverridden?.length != 0) {
        let main = state?.getOverridden?.forEach(function (obj) {
          delete obj[getAccRecPgmORVal];
        });
      }
      return {
        ...state,
        getOverridden: [...state?.getOverridden, action?.getOverridden],
      };
    case actiontypes.QAR_PAID_FULL:
      let getAccRecPgmPDVal = Object.keys(action?.getPaidInFull)?.[0];
      if (state?.getPaidInFull?.length != 0) {
        let main = state?.getPaidInFull?.forEach(function (obj) {
          delete obj[getAccRecPgmPDVal];
        });
      }
      return {
        ...state,
        getPaidInFull: [...state.getPaidInFull, action.getPaidInFull],
      };
    case actiontypes.AR_QTR_ACCOUNT_REC_FIELD_CLEAR_REDUX:
      return action.payload ? action.payload : {};
    default:
      return state;
  }
};

export default reducer;
